import { getScalarValue } from "src/business/attribute/getScalarValue";
import { zSidLabel } from "src/types";
import { Scalar } from "src/types/Scalar";

// Существуют специальные случаи. Например, если строковое поле вообще не заполнялось, то его значение null
// Пользователь что-то вводит, затем стирает. null меняется на "". Но это уже не одинаковые значения.
// Хотя чисто внеше выглядит, что изменений вроде нет
// Чтобы таких проблем не происходило, вводится специальная функция сравнения.
export const isEqualFieldValues = (a: unknown, b: unknown): boolean => {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return !a.find((itemA, i) => !isEqualFieldValues(itemA, b[i]));
  }
  if (Array.isArray(a) || Array.isArray(b)) return false;

  const sa = zSidLabel.safeParse(a);
  const sb = zSidLabel.safeParse(b);
  if (sa.success && sb.success) {
    return sa.data.id === sb.data.id && sa.data.label === sb.data.label;
  }

  return valueToCompare(a) === valueToCompare(b);
};

const valueToCompare = (value: unknown): Scalar => {
  const scalar = getScalarValue(value);
  return scalar === "" || scalar === undefined ? null : scalar;
};
